// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__3P-Z2","loaderOuter":"PageOverlayLoader_loaderOuter__CDunD"};